import { Card } from "@wayflyer/flyui";
import { styled } from "styled-components";

export const VerticalDivider = styled.div`
  height: 36px;
  border-left: 1px solid var(--palette-border-neutral-subtle);
`;

export const StyledCard = styled(Card)`
  border: 1px solid var(--palette-border-neutral-subtle);
`;
